import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Mail, Globe } from "lucide-react";
import { PILLARS } from "../data";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-mm-navy text-white">
    <div className="h-1 w-full flex" aria-hidden="true">
      <span className="flex-1 bg-brand-orange" />
      <span className="flex-1 bg-brand-teal" />
      <span className="flex-1 bg-brand-red" />
      <span className="flex-1 bg-brand-green" />
    </div>
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-20 pb-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-14 border-b border-white/10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <img src="/mars-mining-logo.png" alt="Mars Mining" className="h-11 w-auto" />
            <span className="font-display font-bold text-xl tracking-tight">MARS MINING LIMITED</span>
          </div>
          <p className="text-white/70 leading-relaxed max-w-md">
            A UK-based mining intelligence and strategic project platform enabling secure, sustainable and technology-driven access to critical minerals.
          </p>
          <div className="flex flex-wrap gap-2 mt-6">
            {PILLARS.map((p) => (
              <span key={p} className="font-mono text-[0.6rem] tracking-widest uppercase text-white/60 border border-white/15 rounded px-2.5 py-1.5">{p}</span>
            ))}
          </div>
        </div>

        <div className="lg:col-span-3 lg:col-start-7">
          <p className="font-mono text-xs tracking-[0.2em] uppercase text-mm-accent mb-5">Navigate</p>
          <ul className="space-y-3">
            {["About", "Projects", "Team", "Investors", "Contact"].map((l) => (
              <li key={l}>
                <Link
                  to={`/${l.toLowerCase()}`}
                  data-testid={`footer-link-${l.toLowerCase()}`}
                  className="text-white/70 hover:text-white transition-colors"
                >
                  {l}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <p className="font-mono text-xs tracking-[0.2em] uppercase text-mm-accent mb-5">Get in touch</p>
          <p className="flex items-start gap-2 text-white/70 leading-relaxed">
            <MapPin size={17} className="mt-0.5 shrink-0 text-mm-accent" /> 128 City Road,<br />London EC1V 2NX,<br />United Kingdom
          </p>
          <a
            href="mailto:info@marsminingltd.com"
            data-testid="footer-email"
            className="inline-flex items-center gap-2 mt-4 text-white hover:text-mm-accent transition-colors break-all"
          >
            <Mail size={16} className="text-mm-accent shrink-0" /> info@marsminingltd.com
          </a>
          <a
            href="https://www.marsminingltd.com"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-website"
            className="inline-flex items-center gap-2 mt-2 text-white/70 hover:text-mm-accent transition-colors"
          >
            <Globe size={16} className="text-mm-accent shrink-0" /> www.marsminingltd.com
          </a>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-between gap-3 pt-6">
        <p className="text-sm text-white/50">© {new Date().getFullYear()} Mars Mining Limited · Company Reg. No. 17132212 · All rights reserved.</p>
        <Link to="/contact" data-testid="footer-cta" className="inline-flex items-center gap-1.5 text-sm text-white/70 hover:text-white transition-colors">
          Partner with us <ArrowUpRight size={15} />
        </Link>
      </div>
    </div>
  </footer>
);
